var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "69",
        viewBox: "0 0 69 69",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_7_2)" } }, [
        _c("path", {
          attrs: {
            d: "M58.6654 10.0266C52.212 3.55781 43.6179 0 34.4846 0C15.6328 0 0.292634 15.3402 0.292634 34.192C0.292634 40.2141 1.86362 46.0975 4.85156 51.2879L0 69L18.1279 64.2408C23.1181 66.967 28.7397 68.3993 34.4692 68.3993H34.4846C53.321 68.3993 69 53.0592 69 34.2074C69 25.0741 65.1187 16.4953 58.6654 10.0266ZM34.4846 62.6391C29.3712 62.6391 24.3656 61.2683 20.0069 58.6808L18.975 58.0647L8.22455 60.8833L11.0893 50.3946L10.4116 49.3165C7.56228 44.7884 6.0683 39.5672 6.0683 34.192C6.0683 18.5283 18.821 5.77567 34.5 5.77567C42.0931 5.77567 49.2241 8.73281 54.5839 14.108C59.9437 19.4833 63.2397 26.6143 63.2243 34.2074C63.2243 49.8864 50.1482 62.6391 34.4846 62.6391Z",
            fill: _vm.color,
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M19.2273 24.7273L24.8523 42.4091H25.0682L30.7045 24.7273H36.1591L28.1364 48H21.7955L13.7614 24.7273H19.2273ZM47.4261 48.3182C45.7292 48.3182 44.2178 48.0265 42.892 47.4432C41.5739 46.8523 40.5322 46.0417 39.767 45.0114C39.0095 43.9735 38.6193 42.7765 38.5966 41.4205H43.5511C43.5814 41.9886 43.767 42.4886 44.108 42.9205C44.4564 43.3447 44.9186 43.6742 45.4943 43.9091C46.0701 44.1439 46.7178 44.2614 47.4375 44.2614C48.1875 44.2614 48.8504 44.1288 49.4261 43.8636C50.0019 43.5985 50.4527 43.2311 50.7784 42.7614C51.1042 42.2917 51.267 41.75 51.267 41.1364C51.267 40.5152 51.0928 39.9659 50.7443 39.4886C50.4034 39.0038 49.911 38.625 49.267 38.3523C48.6307 38.0795 47.8731 37.9432 46.9943 37.9432H44.8239V34.3295H46.9943C47.7367 34.3295 48.392 34.2008 48.9602 33.9432C49.536 33.6856 49.983 33.3295 50.3011 32.875C50.6193 32.4129 50.7784 31.875 50.7784 31.2614C50.7784 30.678 50.6383 30.1667 50.358 29.7273C50.0852 29.2803 49.6989 28.9318 49.1989 28.6818C48.7064 28.4318 48.1307 28.3068 47.4716 28.3068C46.8049 28.3068 46.1951 28.428 45.642 28.6705C45.089 28.9053 44.6458 29.2424 44.3125 29.6818C43.9792 30.1212 43.8011 30.6364 43.7784 31.2273H39.0625C39.0852 29.8864 39.4678 28.7045 40.2102 27.6818C40.9527 26.6591 41.9527 25.8598 43.2102 25.2841C44.4754 24.7008 45.9034 24.4091 47.4943 24.4091C49.1004 24.4091 50.5057 24.7008 51.7102 25.2841C52.9148 25.8674 53.8504 26.6553 54.517 27.6477C55.1913 28.6326 55.5246 29.7386 55.517 30.9659C55.5246 32.2689 55.1193 33.3561 54.3011 34.2273C53.4905 35.0985 52.4337 35.6515 51.1307 35.8864V36.0682C52.8428 36.2879 54.1458 36.8826 55.0398 37.8523C55.9413 38.8144 56.3883 40.0189 56.3807 41.4659C56.3883 42.7917 56.0057 43.9697 55.233 45C54.4678 46.0303 53.411 46.8409 52.0625 47.4318C50.714 48.0227 49.1686 48.3182 47.4261 48.3182Z",
            fill: _vm.color,
          },
        }),
      ]),
      _vm._v(" "),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_7_2" } }, [
          _c("rect", { attrs: { width: "69", height: "69", fill: "white" } }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }